export function getLineNumber(text: string, position: number): number | null {
    if (position == null || position < 0 || position >= text.length) {
        return null;
    }
    const lines = text.split('\n');
    let currentLineLength = 0;
    for (let i = 0; i < lines.length; i++) {
        const lineLength = lines[i].length + 1;
        if (position < currentLineLength + lineLength) {
            return i + 1;
        }
        currentLineLength += lineLength;
    }
    return null;
}

const reservedChars: Record<string, string> = { '>': '&gt;', '"': '&quot;', "'": '&apos;' };

export function checkReservedCharacters(text: string): string | null {
    let insideTag = false;
    for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (ch === '<') {
            insideTag = true;
            continue;
        }
        if (ch === '>' && insideTag) {
            insideTag = false;
            continue;
        }
        if (!insideTag && ch in reservedChars) {
            const line = getLineNumber(text, i);
            const atLine = line != null ? ` at line ${line}` : '';
            return `Unescaped reserved character "${ch}"${atLine}. Use ${reservedChars[ch]} instead.`;
        }
    }
    return null;
}

export function minifyXml(text: string): string {
    return text.replace(/\n/g, ' ').replace(/[\t ]+/g, ' ').replace(/> </g, '><').trim();
}

export function getDetailedParseError(xmlContent: string): string {
    const withNamespaces = xmlContent.replace(
        /^(<speak)([\s>])/,
        '$1 xmlns:amazon="http://amazon.com" xmlns:alexa="http://alexa.com" xmlns:google="http://google.com"$2'
    );
    const parser = new DOMParser();
    const doc = parser.parseFromString(withNamespaces, 'application/xml');
    const parseError = doc.querySelector('parsererror');
    if (!parseError) return "Can't parse SSML";
    const errorText = parseError.textContent || '';
    const match = errorText.match(/error on line (\d+) at column (\d+): (.+)/i);
    if (match) {
        return `Parse error on line ${match[1]}, column ${match[2]}: ${match[3].trim()}`;
    }
    return errorText.split('\n')[0].trim() || "Can't parse SSML";
}

export function stringifyError(errorObj: any, text: string): string {
    const lineNumber = getLineNumber(text, errorObj.position);
    const atLine = lineNumber != null ? ` at line ${lineNumber}` : '';
    if (errorObj.type === 'tag' && errorObj.attribute && errorObj.value) {
        return `The tag "${errorObj.tag}" with attribute "${errorObj.attribute}" has invalid value "${errorObj.value}"${atLine}\n`;
    } else if (errorObj.type === 'tag' && errorObj.attribute) {
        return `The tag "${errorObj.tag}" has invalid attribute "${errorObj.attribute}"${atLine}\n`;
    } else if (errorObj.type === 'tag') {
        return `Invalid tag "${errorObj.tag}"${atLine}\n`;
    } else if (errorObj.type === "Can't parse SSML") {
        return getDetailedParseError(text) + '\n';
    } else {
        return `${errorObj.type}${atLine}\n`;
    }
}
